import Page403 from 'components/Page403'
import Spin from 'components/UI/Spin'
import { useProfile } from 'context/ProfileProvider'
import PropTypes from 'prop-types'

function PrivateRoute({ permissions = [], children }) {
  const { profile, hasPermission } = useProfile()

  function hasPermissions() {
    if (!permissions?.length) return true
    return permissions.some(permission => hasPermission(permission))
  }

  // Permissions are not fetched yet
  if (!profile?.permissions) return <Spin size="middle" />

  // Permissions OK
  if (hasPermissions()) return children

  // No permissions: 403
  return <Page403 />
}

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  permissions: PropTypes.array,
}

export default PrivateRoute
